export default __webpack_public_path__ + "4d3fca05f4092859dcc58ceca2ac8faf.png";